"use client";

import { createContext, useContext } from "react";
import { API_ROUTER_CONTEXT_DEFAULT_VALUE } from "../constants/contexts/defaultValues";

/**
 * @typedef {object} ApiRouterContextValue
 * @prop {ReturnType<typeof import("../../account/helpers/router/api").default>} apiRouter
 */

export const ApiRouterContext = createContext(
  /** @type {ApiRouterContextValue} */
  (API_ROUTER_CONTEXT_DEFAULT_VALUE),
);

export function useApiRouter() {
  const value = useContext(ApiRouterContext);

  if (value === API_ROUTER_CONTEXT_DEFAULT_VALUE) {
    throw new Error("useApiRouter must be used within a ApiRouterProvider");
  }

  return value;
}
